import config from "../config";

const API_URL = config.api.endpoints.USER_DATA;
const privateSchoolIds = config.app.privateSchoolIds;

export const fetchUserData = async (accessToken?: string): Promise<any> => {
  try {
    const myHeaders = new Headers();    
    const token = accessToken;
    if (!token) {
        throw new Error("Authorization token is missing. Please log in .");
    }
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions: RequestInit = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const response = await fetch(API_URL, requestOptions);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    // console.log(privateSchoolIds);

    if (result.students?.studentsList?.length > 0) {
        result.students.schoolFullName = [
        ...new Set(result.students.studentsList
        .map((student: any) => student.schoolDetails.name || "UnknownSchool") ) 
        ].join(", ");
        // All students will belong to the same school
        const firstStudentCommon = result.students.studentsList[0];
        const schoolType = firstStudentCommon.schoolDetails.schoolType;
        result.students.schoolShortName = firstStudentCommon.schoolDetails.shortName || "";
        // result.students.schoolType = typeof schoolType === "string" ? schoolType.toLowerCase() : "";

        // Set schoolType based on whether any match private list
        const loggedInUserSchoolId = result.user.schoolId;
        const hasPrivateSchool = privateSchoolIds.includes(loggedInUserSchoolId);
        result.students.schoolType = hasPrivateSchool ? "private" : "public";
    }
    // console.log(result);
    return result;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};
